export const CYNCLY_ITEMS_METADATA = "CYNCLY_items_metadata";
export const CYNCLY_LIGHTS_METADATA = "CYNCLY_lights_metadata";
export const CYNCLY_MATERIALS_METADATA = "CYNCLY_materials_metadata";
export const CYNCLY_MESH_METADATA = "CYNCLY_mesh_metadata";
export const EXT_LIGHTS_IES = "EXT_lights_ies";
export const IES_PROFILE_MIME_TYPE = "application/x-ies-lm-63";